(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing",
                    {
                        url: "/DigitalMarketing",
                        component: "digitalMarketing",
                        PageTitle: "Digital Marketing | Marketing Tracker", 
                        redirectTo: "Home.Tools.MarketingTrackerNew.DigitalMarketing.Dashboard"
                    });
        }
    ]);

    app.component("digitalMarketing",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/digital-marketing-template.html",
            controller: digitalMarketingController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    digitalMarketingController.$inject = [];
    function digitalMarketingController() {

        var $ctrl = this;
    }
})(window.app, window.angular); //jshint ignore:line